import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgGhavamin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#007D3D'
      d='M4.645 3.707H18L13.91-.002H1.417C.24-.002 0 1.651 0 1.651v11.753s.316 5.594 8.018 5.594 6.763-5.2 6.763-5.2-.709 3.153-4.953 3.153-5.183-3.624-5.183-3.624z'
    />
    <path
      fill='#007D3D'
      d='M18.355 20.289H5l4.09 3.709h12.493c1.178 0 1.417-1.653 1.417-1.653V10.6s-.316-5.602-8.018-5.602-6.763 5.2-6.763 5.2.709-3.153 4.953-3.153 5.183 3.624 5.183 3.624z'
    />
    <path
      fill='#FFF400'
      d='M11.703 16.41a4.44 4.44 0 0 0 4.434-4.446 4.44 4.44 0 0 0-4.434-4.446 4.44 4.44 0 0 0-4.435 4.446 4.44 4.44 0 0 0 4.435 4.446'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgGhavamin)
export default ForwardRef
